import { Turnstile } from "react-turnstile";
function TurnstilWidget({onVerify, onError}) {
	return (
		<Turnstile
			sitekey={process.env.REACT_APP_TURNSTILE_PUBLIC_KEY}
			execution="execute"
			type="invisible"
			theme="auto"
			onSuccess={(token)=>{
				onVerify?.(!!token);	
			}}
			onLoad={(widgetId, bound) => {
				// before:
				window.turnstile.execute(widgetId);
				// now:
				bound.execute();
			}}
		/>
	);
}
export default TurnstilWidget;